import {createApp} from 'vue';
import {safeDefine} from '@breuni-ui/safe-define';

export default class ProductFamily extends HTMLElement {
  connectedCallback() {
    import('./product-family.vue.component')
      .then(({
               default: productFamilyVueComponent,
             }) => {
        this.createVueInstance(productFamilyVueComponent);
      });
  }

  createVueInstance(productFamilyVueComponent) {
    const gridRow = this.closest('.ents-reco-container__grid-row');

    const app = createApp(
      productFamilyVueComponent(this, gridRow),
    );

    app.config.compilerOptions.isCustomElement = tag => /^shop-|^bewerten-|^ents-|^suchen-|^kaufen-|^entd-|^brtn-|^camp-|^reco-|^additional-price-info|^loyl-|^klarna-placement/.test(tag);
    app.config.compilerOptions.whitespace = 'preserve';
    app.config.compilerOptions.delimiters = ['[[', ']]'];

    app.mount(this);
  }
}

document.addEventListener('bewe:ents:vue-ready', () => {
  safeDefine('ents-product-family', ProductFamily);
}, {once: true});
